export const ROLES = {
  superAdmin: "SUPER_ADMIN",
  salesPerson: "SALES_PERSON",
};

export const LIGHT_GRAY = "#DEE2E6";

export const GRAY = "#8898aa";
